// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
ActiveStorage.start()

import "../stylesheets/application.scss"
import "../stylesheets/dropzone.scss"
import "../stylesheets/freemotion.scss"
import "../stylesheets/actiontext.scss"
import 'alpine-turbo-drive-adapter'
import "alpinejs"
import "../helpers/data-confirm-tailwind-modal";
import 'tw-elements';

import "controllers";
// import "@rails/actiontext";
import { AttachmentUpload } from "@rails/actiontext/app/javascript/actiontext/attachment_upload"

addEventListener("trix-attachment-add", event => {
  const { attachment, target } = event

  if (attachment.file) {
    const upload = new AttachmentUpload(attachment, target)
    upload.start()
  }
})